/* Lite theme: cart drawer, shipping protection and countdown.
   Every cart change runs through one queue and the drawer is repainted only from the HTML each cart call returns.
   Lines are addressed by key, never by line number. Shopify gives a line a new key whenever its discount changes,
   so taps are remembered per variant and the line's current key is read just before each request. */
(() => {
  const d = document;
  const dlg = d.getElementById('cart-drawer');
  if (!dlg) return;
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const PROT = +dlg.dataset.prot || 0;
  const PRE = dlg.dataset.protOn === 'true';
  const SECS = +dlg.dataset.timer || 0;
  const SEC = 'cart-drawer';
  const store = {
    get: k => { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: (k, v) => { try { v == null ? sessionStorage.removeItem(k) : sessionStorage.setItem(k, String(v)); } catch (e) {} }
  };
  const read = el => ({ count: +(el && el.dataset.count || 0), protQty: +(el && el.dataset.protQty || 0), protKey: (el && el.dataset.protKey) || '' });
  const esc = s => (window.CSS && CSS.escape ? CSS.escape(s) : s);
  const vidOf = key => String(key).split(':')[0];
  const lineOut = (el, vid) => el.querySelector('[data-qty^="' + esc(vid) + ':"]');
  let state = read(dlg.querySelector('.cd'));
  let loaded = !!dlg.querySelector('.cd[data-full]');
  let want = null;
  const pend = {};
  const waits = {};
  let chain = Promise.resolve();
  let jobs = 0;
  const queue = job => { jobs++; const run = chain.then(job); chain = run.catch(() => {}).then(() => { jobs--; }); return run; };
  const settled = async () => { while (jobs) await chain; };

  // Errors carry the HTTP status (0 = no answer) and a message a shopper can read: Shopify's own words for stock
  // limits and rate limits, plain words for a dropped connection or a request it could not use.
  const fault = (status, message) => Object.assign(new Error(message), { status });
  async function api(path, body) {
    let res;
    try {
      res = await fetch(root + path, body
        ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }
        : { headers: { Accept: 'application/json' } });
    } catch (e) {
      throw fault(0, 'Could not reach the store. Check your connection and try again.');
    }
    let json = {};
    try { json = await res.json(); } catch (e) {}
    if (!res.ok) {
      const said = (res.status === 422 || res.status === 429) && (json.description || json.message);
      throw fault(res.status, said && said !== 'Cart Error' ? said : 'Something went wrong. Please try again.');
    }
    return json;
  }
  const post = (path, body) => api(path, Object.assign(body, { sections: SEC })).then(render);
  const reload = () => api('?sections=' + SEC).then(render);

  // The last drawer the cart sent: when a change fails and the drawer cannot be fetched either, the drawer goes back to it,
  // so it never shows a quantity or a switch the cart does not hold.
  let last = null;
  function render(json) {
    const html = json && ((json.sections && json.sections[SEC]) || json[SEC]);
    if (typeof html === 'string') paint(html);
    return json;
  }

  function paint(html) {
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.cd');
    if (!fresh) return;
    last = html;
    // Taps still on their way go into the new drawer before it is shown, so the switch never slides back
    // and the total never passes through a state the shopper already left.
    const sw = fresh.querySelector('[data-prot-switch]');
    if (sw && want !== null) sw.checked = want;
    const n = showPending(fresh);
    showTotal(fresh);
    const old = dlg.querySelector('.cd');
    const body = old && old.querySelector('.cd__body');
    const top = body ? body.scrollTop : 0;
    const a = d.activeElement;
    // Safari moves focus to the dialog itself on a tap inside it; the title takes it back, never ringed.
    const focus = a && dlg.contains(a) ? a.dataset.f || (a === dlg ? 'title' : 'close') : null;
    if (old) old.replaceWith(fresh); else dlg.append(fresh);
    loaded = true;
    state = read(fresh);
    const nb = fresh.querySelector('.cd__body');
    if (nb) nb.scrollTop = top;
    if (focus) { const t = fresh.querySelector('[data-f="' + esc(focus) + '"]') || fresh.querySelector('[data-f="close"]'); if (t) t.focus({ preventScroll: true }); }
    badges(n);
    if (!state.count) store.set('cart-exp', null);
    queue(repair).catch(() => {});
  }

  const badges = n => d.querySelectorAll('[data-cart-count]').forEach(b => { b.textContent = n; b.hidden = !n; });

  // Line taps show at once: the number changes, a line at 0 goes, the item count follows.
  // Prices dim until the cart answers, since removing a line can change the discount on the others.
  function showPending(cd) {
    let gone = false;
    for (const v in pend) {
      const o = lineOut(cd, v);
      if (!o) continue;
      o.textContent = pend[v];
      if (!pend[v]) { o.closest('.ci').hidden = true; gone = true; }
    }
    const n = [...cd.querySelectorAll('.ci:not([hidden]) [data-qty]')].reduce((a, o) => a + +o.textContent, 0);
    cd.querySelectorAll('[data-count-text]').forEach(h => { h.textContent = (n === 1 && h.dataset.countOne || h.dataset.countText).split('[count]').join(n); });
    if (gone) cd.classList.add('cd--busy');
    const empty = cd.querySelector('[data-empty]');
    if (!n && empty && empty.hidden) {
      empty.hidden = false;
      cd.querySelectorAll('.cd__timer,.cd__body,.cd__foot').forEach(el => { el.hidden = true; });
    }
    return n;
  }

  // The totals follow the switch: each comes with its value with and without protection.
  function showTotal(cd) {
    const sw = cd.querySelector('[data-prot-switch]');
    if (!sw) return;
    cd.querySelectorAll('.cd__foot [data-on]').forEach(t => {
      const v = sw.checked ? t.dataset.on : t.dataset.off;
      if (v && t.textContent !== v) t.textContent = v;
    });
  }

  // Protection never sits alone in a cart and never counts twice (two would also trigger the pair discount).
  function repair() {
    if (!PROT || want !== null || !state.protKey) return;
    if (!state.count) return post('cart/change.js', { id: state.protKey, quantity: 0 });
    if (state.protQty > 1) return post('cart/change.js', { id: state.protKey, quantity: 1 });
  }

  function fail(err) {
    return reload().catch(() => { if (last) paint(last); }).then(() => {
      const p = dlg.querySelector('[data-cart-error]') || dlg.querySelector('.cd__empty p, p.cd__empty');
      if (p) { p.textContent = err.message; p.hidden = false; }
    });
  }

  // The switch shows the shopper's last tap at once; the cart follows one request at a time.
  function syncProt() {
    if (want === null) return;
    if (want === state.protQty > 0) { want = null; return; }
    const w = want;
    const job = w ? post('cart/add.js', { items: [{ id: PROT, quantity: 1 }] }) : post('cart/change.js', { id: state.protKey, quantity: 0 });
    return job.then(() => {
      if (want === w) { want = null; queue(repair); } else queue(syncProt);
    }, err => { want = null; return fail(err); });
  }

  function flush(vid) {
    if (!(vid in pend)) return;
    const q = pend[vid];
    delete pend[vid];
    const out = lineOut(dlg, vid);
    if (!out) return;
    const change = o => post('cart/change.js', { id: o.dataset.qty, quantity: q });
    // A 400 means the line's key changed since this drawer was drawn (another tab changed the cart):
    // fetch the drawer and send the tap once more with the line's new key.
    return change(out).catch(err => {
      if (err.status !== 400) throw err;
      return reload().then(() => { const o = lineOut(dlg, vid); if (o) return change(o); });
    }).catch(fail);
  }

  dlg.addEventListener('change', e => {
    const sw = e.target.closest('[data-prot-switch]');
    if (!sw) return;
    want = sw.checked;
    store.set('prot-off', want ? null : '1');
    showTotal(dlg.querySelector('.cd'));
    queue(syncProt);
  });

  // Checkout waits for taps still on their way, so it opens with what the drawer shows.
  let leaving = false;
  dlg.addEventListener('submit', e => {
    const b = e.submitter;
    if (!b || b.name !== 'checkout' || (!leaving && !jobs && !Object.keys(pend).length)) return;
    e.preventDefault();
    if (leaving) return;
    leaving = true;
    for (const v in pend) { clearTimeout(waits[v]); queue(() => flush(v)); }
    settled().then(() => {
      leaving = false;
      const c = dlg.querySelector('button[name="checkout"]');
      const err = dlg.querySelector('[data-cart-error]');
      if (c && (!err || err.hidden)) c.click();
    });
  });

  dlg.addEventListener('click', e => {
    if (e.target === dlg) { dlg.close(); return; }
    const b = e.target.closest('[data-step],[data-remove]');
    if (!b) return;
    const vid = vidOf(b.dataset.key);
    const out = lineOut(dlg, vid);
    const cur = vid in pend ? pend[vid] : +(out ? out.textContent : 0);
    const next = b.hasAttribute('data-remove') ? 0 : Math.max(0, cur + +b.dataset.step);
    pend[vid] = next;
    const li = out && out.closest('.ci');
    const had = li && li.contains(d.activeElement);
    badges(showPending(dlg.querySelector('.cd')));
    if (had && li.hidden) { const c = dlg.querySelector('[data-f="close"]'); if (c) c.focus({ preventScroll: true }); }
    clearTimeout(waits[vid]);
    waits[vid] = setTimeout(() => queue(() => flush(vid)), next ? 300 : 0);
  });

  // Opening puts focus on the title rather than the first button: Safari draws a focus ring on a button focused this way,
  // even after a tap. Browsers without <dialog> (iOS before 15.4) get the cart page instead, which works without scripts.
  function open(refresh) {
    if (typeof dlg.showModal !== 'function') { location.href = root + 'cart'; return; }
    if (!dlg.open) {
      dlg.showModal();
      const t = dlg.querySelector('.cd__title');
      if (t) t.focus({ preventScroll: true });
    }
    if (!loaded || refresh !== false) queue(reload).catch(fail);
  }

  d.addEventListener('click', e => {
    const o = e.target.closest('[data-cart-open]');
    if (!o || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    open();
  });

  if (SECS > 0 && !customElements.get('cart-timer')) {
    customElements.define('cart-timer', class extends HTMLElement {
      connectedCallback() { this.tick(); }
      disconnectedCallback() { clearTimeout(this.h); }
      tick() {
        const t = this.querySelector('time');
        if (!t) return;
        let exp = +store.get('cart-exp');
        if (!exp) { exp = Date.now() + SECS * 1000; store.set('cart-exp', exp); }
        const left = Math.max(0, exp - Date.now());
        const s = Math.ceil(left / 1000);
        t.textContent = String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
        if (left > 0) this.h = setTimeout(() => this.tick(), left % 1000 || 1000);
      }
    });
  }

  window.theme = {
    cart: {
      // Protection rides along with the first add; if that line is refused, the items still go in alone.
      add(items) {
        return queue(() => {
          const exp = +store.get('cart-exp');
          if (!exp || exp < Date.now()) store.set('cart-exp', Date.now() + SECS * 1000);
          const ride = PROT && PRE && !state.protQty && store.get('prot-off') !== '1' && !items.some(i => i.id === PROT);
          if (!ride) return post('cart/add.js', { items });
          return post('cart/add.js', { items: items.concat({ id: PROT, quantity: 1 }) }).catch(() => post('cart/add.js', { items }));
        });
      },
      open
    }
  };

  // The cart page is plain HTML forms; this only repairs the protection line and remembers an opt-out.
  const page = d.querySelector('[data-cart-page]');
  if (page) {
    const s = read(page);
    if (PROT && s.protKey && (!s.count || s.protQty > 1)) api('cart/change.js', { id: s.protKey, quantity: s.count ? 1 : 0 }).then(() => location.reload(), () => {});
    page.addEventListener('click', e => {
      if (e.target.closest('[data-prot-remove]')) store.set('prot-off', '1');
      if (e.target.closest('[data-prot-add]')) store.set('prot-off', null);
    });
  }

  const menu = d.querySelector('[data-menu]');
  if (menu) {
    d.addEventListener('click', e => { if (menu.open && !menu.contains(e.target)) menu.open = false; });
    d.addEventListener('keydown', e => { if (e.key === 'Escape' && menu.open) { menu.open = false; menu.querySelector('summary').focus(); } });
  }

  window.addEventListener('pageshow', e => { if (e.persisted) queue(reload).catch(() => {}); });
})();

/* Reviews: the row scrolls natively; the arrows and dots move it one card and the lit dot follows the centred card. */
(() => {
  const smooth = () => (matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth');
  document.querySelectorAll('[data-rv]').forEach(list => {
    const sec = list.closest('.rv');
    const real = [...list.children];
    const n = real.length;
    const dots = [...sec.querySelectorAll('[data-rv-to]')];
    if (n < 2) return;
    // Endless: copies of the last two cards go before the first and of the first two after the last,
    // so both neighbours always peek in. Landing on a copy jumps to its card without a visible move.
    real.forEach((c, i) => { c.dataset.i = i; });
    const copy = c => {
      const x = c.cloneNode(true);
      x.setAttribute('aria-hidden', 'true');
      x.inert = true;
      [...x.attributes].forEach(a => { if (a.name.startsWith('data-shopify')) x.removeAttribute(a.name); });
      return x;
    };
    const k = Math.min(2, n);
    list.prepend(...real.slice(-k).map(copy));
    list.append(...real.slice(0, k).map(copy));
    const all = [...list.children];
    const left = c => c.offsetLeft - (list.clientWidth - c.offsetWidth) / 2;
    const at = () => {
      const mid = list.scrollLeft + list.clientWidth / 2;
      let best = 0, gap = Infinity;
      all.forEach((c, d) => { const g = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid); if (g < gap) { gap = g; best = d; } });
      return best;
    };
    let frame = 0, timer = 0;
    const mark = () => { frame = 0; const i = all[at()].dataset.i; dots.forEach(b => b.toggleAttribute('aria-current', b.dataset.rvTo === i)); };
    const settle = () => { const c = all[at()]; if (c.inert) list.scrollLeft = left(real[+c.dataset.i]); };
    const ends = 'onscrollend' in window;
    list.addEventListener('scroll', () => {
      if (!frame) frame = requestAnimationFrame(mark);
      if (!ends) { clearTimeout(timer); timer = setTimeout(settle, 150); }
    }, { passive: true });
    if (ends) list.addEventListener('scrollend', settle);
    sec.addEventListener('click', e => {
      const b = e.target.closest('[data-rv-step],[data-rv-to]');
      if (!b) return;
      const c = b.hasAttribute('data-rv-to') ? real[+b.dataset.rvTo] : all[Math.max(0, Math.min(all.length - 1, at() + +b.dataset.rvStep))];
      list.scrollTo({ left: left(c), behavior: smooth() });
    });
    // Placed once the row comes near: phones start on the first card, wide screens on the third with two on each
    // side.
    const io = new IntersectionObserver(es => {
      if (!es[0].isIntersecting) return;
      io.disconnect();
      list.scrollLeft = left(real[n > 4 && matchMedia('(min-width: 750px)').matches ? 2 : 0]);
      mark();
    }, { rootMargin: '600px 0px' });
    io.observe(list);
  });
})();
